import { useElapsed } from './useElapsed';

/** Displays elapsed time from startTime, updating every second. */
export function ElapsedTimer({ startTime }: { startTime: number }) {
  return <>{useElapsed(startTime)}</>;
}
